module.exports = __webpack_public_path__ + "img/city.98f00613.png";